import { observable, action, computed } from "mobx";
import { HTML2React } from "../../../utils";

import {
  IFile,
  IFilesChecked,
  ICourse,
  ICoursesGroup,
  ICoursesGroups,
} from "./types";
import api from "../../../api";

export default class FSStore {
  rootStore: any;
  constructor(RootStore: any) {
    this.rootStore = RootStore;

    this.isLoading = true;

    this.course_id = 0;
    this.course_name = ``;
    this.course_cover = ``;

    this.lesson_id = 0;

    this.filesCheckedStorage = [];
    this.filesChecked = [];
    this.filesCheckedWarning = false;
    this.addVideoLink = false;
    this.addVideoLinkTriggered = false;

    this.salt = new Date().getTime();

    this.wasLoaded = false;
  }

  module = "student";
  canDownload = false;
  canEdit = false;
  canDelete = false;

  isWidget: boolean;
  onProtect?: any;
  onCancel?: any;
  onTranscribeCreate?: any;
  onAttach?: any;

  filesCheckedStorage?: IFilesChecked;
  @observable filesChecked: IFilesChecked;
  @observable filesCheckedWarning: boolean;
  @observable addVideoLink: boolean;
  @observable addVideoLinkTriggered: boolean;

  @observable isLoading: boolean;

  @observable course_id: number;
  @observable student_id: number;
  @observable course_name: string;
  @observable course_cover: string;

  @observable lesson_id: number;

  @observable salt: number;

  @observable wasLoaded: boolean;

  @observable filesCount: number = 0;

  @computed get isFilesCheckAvailable() {
    return !!this.onAttach || !!this.onProtect;
  }

  @computed get getCheckedFilesCount() {
    return this.filesChecked.length;
  }

  @computed get isFileChecked() {
    return (data: IFile) => {
      return !!this.filesCheckedStorage.find(
        (file: IFile) => file.id === data.id
      );
    };
  }

  onAttachAll = (data?: Array<IFile>) => {
    const filesList: Array<IFile> = [];
    this.filesChecked.map((file: IFile) => {
      filesList.push(file);
    });
    if (data) {
      data.map((file: IFile) => {
        filesList.push(file);
      });
    }
    this.onAttach(filesList);
  };

  onAttachVideoLink = (data: string) => {
    this.onAttach(data);
  };

  @action
  setLoading = (trigger: boolean = true) => {
    this.isLoading = trigger;
  };

  @action
  onChangeCourse = (course?: {
    id?: number;
    name?: string;
    icon?: string;

    filestorageSpaceTotal?: number;
    filestorageSpaceUsed?: number;

    isHaveFilesInCourse?: boolean;
    isHaveFilesInAll?: boolean;
  }) => {
    this.course_id = course ? course.id : 0;
    this.course_name = course ? HTML2React(course.name) : ``;
    this.course_cover = course ? course.icon : ``;

    this.rootStore.fsCourseStore.filestorageSpaceTotal = course
      ? course.filestorageSpaceTotal
      : 0;
    this.rootStore.fsCourseStore.filestorageSpaceUsed = course
      ? course.filestorageSpaceUsed
      : 0;

    this.rootStore.fsCourseStore.isHaveFilesInCourse = course
      ? course.isHaveFilesInCourse
      : false;
    this.rootStore.fsCourseStore.isHaveFilesInAll = course
      ? course.isHaveFilesInAll
      : false;

    this.wasLoaded = true;

    let url = "/panel/files/courses";
    if (course?.id) {
      url += "?course_id=" + course.id;
      url += this.rootStore.fsCourseStore.filesSection
        ? "&section=" + this.rootStore.fsCourseStore.filesSection
        : "";
      url += this.rootStore.fsCourseStore.filesSectionTab
        ? "&sectionTab=" + this.rootStore.fsCourseStore.filesSectionTab
        : "";
      url += this.student_id ? "&student_id=" + this.student_id : "";
    }
    if (!this.isWidget) {
      (window as any).history.pushState("", "", url);
    }
    setTimeout(() => {
      (window as any).lineClamp();
    }, 0);
  };

  @action
  onFileCheck = (data: IFile) => {
    const index = this.filesCheckedStorage.findIndex(
      (file: IFile) => file.id === data.id
    );
    if (index >= 0) {
      this.filesCheckedStorage.splice(index, 1);
    } else {
      this.filesCheckedStorage.push(data);
    }
    this.filesChecked = this.filesCheckedStorage;
  };

  @action
  uncheckCheckedFiles = () => {
    [].forEach.call(
      document.querySelectorAll(".filestorage input[type=checkbox]:checked"),
      function(el: any) {
        el.checked = false;
      }
    );
    this.filesCheckedStorage = [];
    this.filesChecked = [];
  };

  @action
  switchCheckedFilesWarning = (
    switcher = true,
    uncheck = false,
    addVideoLink = false
  ) => {
    this.addVideoLinkTriggered = addVideoLink;
    this.filesCheckedWarning = switcher;
    if (uncheck) {
      this.uncheckCheckedFiles();
    }
    if (!switcher) {
      if (this.addVideoLinkTriggered) {
        this.toggleAddVideoLink();
      } else {
        document.getElementById("filestorage-upload").click();
      }
    }
  };

  @action
  closeCheckedFilesWarning = () => {
    this.filesCheckedWarning = false;
  };

  @action
  toggleAddVideoLink = () => {
    this.addVideoLink = !this.addVideoLink;
  };

  @action
  setInitialStore = (data: any) => {
    this.module = data.module;
    this.canDownload = data.canDownload;
    this.canEdit = data.canEdit;
    this.canDelete = data.canDelete;
    this.isWidget = data.isWidget;

    this.course_id = 0;
    this.student_id = data.student_id;
    this.lesson_id = data.lesson_id ? data.lesson_id : 0;
    this.course_name = ``;
    this.course_cover = ``;

    this.onProtect = !!data.onProtect
      ? () => {
          let filesList = ``;
          this.filesChecked.map((file: IFile) => {
            filesList += file.attachedCode;
          });
          data.onProtect(filesList);
        }
      : undefined;
    this.onCancel = !!data.onCancel
      ? () => {
          this.filesCheckedStorage = [];
          this.filesChecked = [];
          var s = window.location.hash.toString();
          if (s != "#filestorage") {
            history.pushState(
              "",
              document.title,
              window.location.pathname + window.location.search
            );
          }
          data.onCancel();
        }
      : undefined;
    this.onAttach = !!data.onAttach
      ? (payload: string) => {
          this.uncheckCheckedFiles();
          data.onAttach(payload);
        }
      : undefined;

    this.isLoading = true;
    this.wasLoaded = false;
    if (data.type) {
      this.rootStore.fsCourseStore.filterFilesType = data.type;
    }
    if (data.section) {
      this.rootStore.fsCourseStore.filesSectionInitial = data.section;
      this.rootStore.fsCourseStore.filesSection = data.section;
      if (data.section !== "lessons") {
        this.rootStore.fsCourseStore.filesSectionTab = data.tab
          ? data.tab
          : "all";
      }
    }
  };

  @action
  async uploadVideoViaLink(link: string, name: string) {
    console.log(this);
    try {
      const res = await api.file.uploadByLink([{link, name}], this.course_id, null, this.lesson_id);

      return res;
    } catch (error) {
      
    }
  }

  @action 
  async removeFiles(all?: boolean) {
    const res = await api.file.remove(all ? 'all' : this.filesChecked.map(f => f.id), this.course_id);
    this.filesChecked = [];
    this.salt = new Date().getTime();
  }
}

export { FSStore };
